import "./style.scss";
import {ReactComponent as DropdownIcon} from "assets/icons/dropdownTransparent.svg";
import { formatNumber } from "helpers/helpers";

const ChangeIndicator = ({change=0, showFull=true}) => {
  
  if(change.percentage >= 0)
  return <div className="changeIndicator _greenColor">
    <DropdownIcon fill="var(--green700)" style={{transform:"rotate(180deg)"}}/>
    { showFull &&
      <p className="changeIndicatorTitle">${formatNumber(change.amount,"auto")}</p>
    }
    <p className="changeIndicatorPercentage">{ showFull ? "("+formatNumber(change.percentage,2)+"%)" : formatNumber(change.percentage,2)+"%"}</p>
  </div>

  if(change.percentage < 0)
  return <div className="changeIndicator _redColor">
    <DropdownIcon fill="var(--red700)"/>
    { showFull &&
      <p className="changeIndicatorTitle">${formatNumber(change.amount,"auto")}</p>
    }
    <p className="changeIndicatorPercentage">{ showFull ? "("+formatNumber(change.percentage,2)+"%)" : formatNumber(change.percentage,2)+"%"}</p>
  </div>
}

export default ChangeIndicator;